<template>
  <!-- <div class="pic_area">
    <div class="pic_area_input">
      <input @input="theInput" type="number" placeholder="不用加63 直接输入09或9开头号码" v-model="inputNumber" maxlength="11"
        autofocus="autofocus">
    </div>
    <br>
  </div> -->

  <!-- 新添加代码 start -->
  <div class="area-input flex-row">
    <div class="left flex-row">
      <img src="@/static/images/mobile.png" />
      <span>+63</span>
    </div>
    <div class="enter flex-1 flex-column">
      <!-- autofocus="autofocus" -->
      <input v-model="inputNumber" type="number" placeholder="请输入菲律宾手机号码" maxlength="11"
      @input="theInput" @focus.stop="mobileFocus" @blur="mobileBlur" />

      <!-- 历史号码 -->
      <div v-show="historyShow" class="history">
      	<div class="history-sub">
      		<div v-for="item in historyList" :key="item" class="history-item" @click="historyTap(item)">
      			{{ item }}
      		</div>
      		<div class="history-item flex_center">
      			<div class="history-tips">
      				<span>常用号码</span>
      			</div>
      		</div>
      	</div>
      </div>

    </div>
  </div>
  <!-- 新添加代码 start -->
</template>

<script>
  const delay = (function() {
    let timer = 0
    return function(callback, ms) {
      clearTimeout(timer)
      timer = setTimeout(callback, ms)
    }
  })()

  export default {
    name: "inputArea",
    data() {
      return {
        inputNumber: "",
        inputNumber2: "",
        theCheck: '',
        theType: '',
        historyShow: false,
        historyList: [],
        isFocused: false
      }
    },
    computed: {
      authToken() {
        return localStorage.getItem('auth_token')
      }
    },
    mounted() {
      var _vm = this;
      var usinfo = sessionStorage.getItem(name + 'usinfo');
      if (usinfo) {
        var u = JSON.parse(usinfo);
        if (u.Commonnumber) {
          _vm.inputNumber = u.Commonnumber;
          _vm.theInput();
        }
      }
    },
    methods: {
      // 号码输入框聚焦
      async mobileFocus() {
      	if (this.isFocused) return;
      	this.isFocused = true;
      	if (!this.authToken) return;
      	const res = await this.getPhoneHistory();
      	this.historyList = res;
      	if (res && res.length > 0)
      	  this.historyShow = true;
      },
      // 获取历史号码列表
      getPhoneHistory() {
      	return new Promise((resolve, reject) => {
          this.$api.request('Member/phoneHistory')
          .then((res) => {
            resolve(res.data)
          })
          .catch(error => {
            this.$message({
              message: error+"加载数据失败，请检查网络！",
              type: "warning"
            })
          })
      	})
      },
      // 选择历史号码
      historyTap(item) {
      	this.inputNumber = item;
        this.theInput();
        this.setHistory(false)
      },
      // 号码输入框失焦
      mobileBlur() {
      	setTimeout(() => {
          this.$nextTick(() => {
            this.setHistory(false)
          })
      	}, 200)
      },
      setHistory(val) {
      	this.historyShow = val;
      	this.isFocused = val;
      },
      theInput: function(e) {
        if (this.inputNumber && this.inputNumber.length > 0) this.setHistory(false)

        this.$emit("func", "NAN", "NAN", true);
        this.inputNumber = this.inputNumber.replace(/^\.+|[^\d.]/g, '').slice(0, 11);

        var Num = this.inputNumber;


        if (Num.length == 4) {


          var check = this.common.test(Num);
          switch (check) {
            case 1:
              this.theType = 1;

              break;
            case 2:
              this.theType = 2;

              break;
            case 3:
              this.theType = 3;

              break;
            case 4:
              this.theType = 4;

              break;

          }
          this.$emit("func", this.inputNumber, this.theType, false)

        }
        if (Num.length > 4) {
          delay(() => {
            var check = this.common.test(Num);
            //console.log(Num.length,check)
            switch (check) {
              case 1:
                this.theType = 1;

                break;
              case 2:
                this.theType = 2;

                break;
              case 3:
                this.theType = 3;

                break;
              case 4:
                this.theType = 4;

                break;

            }

            this.$emit("func", this.inputNumber, this.theType, false)

          }, 500)

        }



      }


    },
    created: function() {},

  }
</script>
<style lang="less" scoped>
  input::-webkit-input-placeholder {
    // font-size: 14px;
    font-size: 24px;
    // color: #878787;
    color: rgba(86, 86, 86, .43);
  }

  .area-input {
    height: 58px;
    border-radius: 3px;
    background: rgba(218, 218, 218, 0.56);
    padding: 0 17px;
    text-align: left;
    margin-bottom: 12px;

    .left {

      img {
        width: 22px;
        height: auto;
        margin-right: 6px;
      }

      span {
        color: rgb(86, 86, 86);
        font-family: 思源黑体;
        font-size: 18px;
        font-weight: 500;
        line-height: 26px;
      }

    }

    .enter {
      height: 100%;
      padding-left: 8px;
      position: relative;
      z-index: 12;
      input {
        width: 100%;
        height: 100%;
        border: none;
        box-sizing: border-box;
        outline: none;
        // font-size: 14px;
        font-size: 30px;
      }

      .history {
      	width: 100%;
      	position: absolute;
      	background: #fff;
      	top: 58px;
      	left: 0;
      	z-index: 999;
      	border: 1px solid #EBEEF5;
      	border-radius: 6px;
      	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

      	&-tips {
      		display: flex;
      		justify-content: center;
      		align-items: center;
      		span {
      			font-size: 16px;
      			color: #b22830;
      			letter-spacing: 1rpx;
            font-weight: 400;
      		}
      	}

      	&-sub {
      		padding: 4px 10px;
      		position: relative;

      		&::before {
      			content: '';
      			position: absolute;
      			top: -8px;
      			left: 25px;
      			border-left: 8px solid transparent;
      			border-right: 8px solid transparent;
      			border-bottom: 8px solid #EBEEF5;
      			z-index: 998;
      		}
      		&::after {
      			content: '';
      			position: absolute;
      			top: -7px; /* 向下偏移1px露出上边框 */
      			left: 26px;
      			border-left: 7px solid transparent;
      			border-right: 7px solid transparent;
      			border-bottom: 7px solid #fff;
      			z-index: 999;
      		}
      	}

      	&-item {
      		height: 42.5px;
      		line-height: 42.5px;
      		font-size: 16px;
      		color: #000;
      		// padding: 0 20rpx;
      		border-bottom: 2px dashed #F0F0F0;
      		text-align: center;
          cursor: pointer;
          font-weight: bold;
          letter-spacing: 0.5px;

      		&:last-child {
      			border-bottom: none;
      		}
      	}
      }
    }

  }

  @media screen and (min-width: 750px) {
    .area-input {
      .enter {
      	.history {
          width: 200px;
      		top: 55px;
      		left: 0;
      	}
      }
    }
  }

  /* .pic_area {
    height: 2.5rem;
    line-height: 2.5rem;

    border-bottom: 1px solid #959595;
    display: flex;
    position: relative;

  }

  .pic_area::before {
    content: "";
    position: absolute;
    top: -10px;
    left: -35px;
    width: 44px;
    height: 44px;
    background-image: url(../../static/images/logo.png);
    background-size: 100% 100%;
    background-position: center;
  }

  .pic_area_input {
    width: 100%;
    flex-wrap: wrap;
    display: flex;
    align-items: center;

  }

  .pic_area_input input {
    width: 100%;
  }

  input {
    border: 0;
    padding: 0;
    outline: none;
    height: 30px;
    font-size: 1em;
    margin: 0 10px;
    text-align: center;
  }

  input::-webkit-input-placeholder {
    text-align: center;
    font-size: 1em;
  } */
</style>



// WEBPACK FOOTER //
// src/components/inputArea.vue